module.exports = __webpack_public_path__ + "media/dashboard/assets/images/info_bg-54dd874741cf847edf79e55b63e7d545.svg";